<template>
	<div class="main-contents">
		<!-- 로그인 폼 -->
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>로그인</span><br/>
					그레이트 프로에 오신 것을 환영합니다.
				</div>
				
				<div class="loginbox">

					<!-- 로그인 탭 -->
					<div class="login-tab">
						<ul class="login-tab-list">
							<li :class="{ on: activeTab === 'tech' }" @click="setActiveTab('tech')">
								<a>IT프로 회원</a>
							</li>
							<li :class="{ on: activeTab === 'company' }" @click="setActiveTab('company')">
								<a>기업회원</a>
							</li>
						</ul>
					</div>

					<!-- IT프로 회원 로그인 -->
					<div class="loginform" v-if="activeTab == 'tech'">
						<div class="inputlist"><InputComp v-model.trim="id" @keyup.enter="login" placeholder="아이디" /></div>
						<div class="inputlist"><InputComp type="password" v-model="password" @keyup.enter="login" placeholder="비밀번호" /></div>
						<SelectComp tagName="div" class="inputlist mt-2" type="yn" title="로그인 상태 유지" v-model="keepLoginYn" />
						
						<div class="login-btn" @click="login">로그인</div>
						<div class="kakao-btn" @click="goKakao"><img src="/images/mem/kakao_sync_btn.png" alt="카카오로 시작하기"></div>

						<div class="loginsmenu">
						<a @click="pageMove('MEM002M06')">아이디 찾기</a><span>ㅣ</span><a @click="pageMove('MEM002M02')">비밀번호 찾기</a><span>ㅣ</span><a @click="pageMove('MEM003M01')">회원가입</a>
						</div>
					</div>
					<!-- 기업회원 로그인-->
					<div class="loginform" v-if="activeTab == 'company'">
						<div class="inputlist"><InputComp v-model="id" @keyup.enter="login" placeholder="아이디" /></div>
						<div class="inputlist"><InputComp type="password" v-model="password" @keyup.enter="login" placeholder="비밀번호" /></div>
						<SelectComp tagName="div" class="inputlist mt-2" type="yn" title="로그인 상태 유지" v-model="keepLoginYn" />
						<div class="login-btn" @click="login">로그인</div>
						<div class="loginsmenu">
						<a @click="pageMove('MEM002M06')">아이디 찾기</a><span>ㅣ</span><a @click="pageMove('MEM002M02')">비밀번호 찾기</a><span>ㅣ</span><a @click="pageMove('MEM003M01')">회원가입</a>
						</div>
					</div>
				</div> <!-- login box -->
			</div><!-- //contents_body -->
			</div><!-- //contents -->
		</div><!-- //main-contents -->
</template>
<script>
import { loginMeta } from '@/utils/meta';

export default {
	metaInfo : loginMeta,
	data() {
		return {
			id: "",
			password: "",
			keepLoginYn: '',
			activeTab: 'tech', //기본 탭을 IT프로 로그인
			mberAsgRegInfo: {},

			mberInfo:{},
			userDstic:'',
			inputable : {
				name : ["han"],
				id : ["lowr","num"],
				email : "A-Za-z_.",
				domain : "a-z.",
				birth : ["num"]
			},
		};
	}, 	


	created() {
    // document.title = "그레이트프로 로그인"

		// console.log(this.$router.history);
  	},


	methods: {
		setActiveTab(tab) {
			this.activeTab = tab;
		},
		
		login() {
			if(!this.id) {
				alert("아이디를 입력하지 않았습니다.");
				return;
			}

			if(!this.password) {
				alert("비밀번호를 입력하지 않았습니다.");
				return;
			}

			var idCheck = this.idChk();
			if(!idCheck) return;

			// this.$.login(this.id, this.password, this.keepLoginYn)
			// 	.then((res) => {
			// 		//console.log("getUserInfo success", res.data);
			// 		var viewNm = 'MYP101M01';
			// 		if(res.data.mberDivCd == '21') viewNm = 'MYP201M01';
			// 		else if(res.data.mberDivCd == '22') viewNm = 'MYP301M01';
			// 		else if(res.data.mberDivCd == '31') viewNm = 'MYP401M01';

			// 		if(res.data.mberDivCd == '11' && res.data.prfCnt == 0) {
			// 			this.$.popup('/mem/MEM001P01')
			// 				.then(res => {
			// 					viewNm = res.viewNm;
			// 					location.href = "/" + viewNm;
			// 				});
			// 		}else if(res.data.mberDivCd == '11' && res.data.ncsCnt == 0) {
			// 			this.$.popup('/tec/prf/PRF101P02')
            //                 .then(res => {
            //                     if(res) viewNm = 'PRF102M02';
                                
			// 					location.href = "/" + viewNm;
            //                 });
			// 		}else if(res.data.mberDivCd.substr(0, 1) == '0'){
			// 			location.href = "/admin";
			// 		}else {
			// 			location.href = "/" + viewNm;
			// 		}
			// 	})
			// 	.catch(this.$.httpErrorCommon);

			//회원유형 맞으면 로그인 요청 보냄
			this.$.login(this.id, this.password, this.keepLoginYn, this.activeTab)
				.then((res) => {
					//const mberDivCd = res.data.mberDivCd;
					// console.log("getUserInfo success", res);
					
					// 로그인 후 화면 이동 > (25.05.19) 계정별 마이페이지에서 메인화면으로 변경
					// var viewNm = 'MYP101M01';
					// if(res.data.mberDivCd == '21') viewNm = 'MYP201M01';
					// else if(res.data.mberDivCd == '22') viewNm = 'MYP301M01';
					// else if(res.data.mberDivCd == '31') viewNm = 'MYP401M01';
					var viewNm = '';

					// 타화면에서 미로그인 상태로 redirect시 로그인 이후 화면 설정 (임시)
					var history = this.$router.history;
					if(history.current.redirectedFrom)
						viewNm = history.current.redirectedFrom.replace('/','');
					
					// IT프로 직원구분코드 조회
					if(res.data.mberDivCd == '11'){

						this.$.httpPost('/api/mem/prf/getMberAsgRegInfo', {mberSeq : this.$store.state.userInfo.mberSeq})
						.then(mberRes => {
							this.mberAsgRegInfo = mberRes.data.mberAsgRegInfo;
							
							// 이력서 등록대행 미완료 && 이력서 미작성 || 소속사 미등록
							if((res.data.regAgncYn == 'N' && res.data.prfCnt == 0) ||this.mberAsgRegInfo.mberAsgRegYn == 'N') {
								// this.$.popup('/tec/prf/PRF101P04')
								this.$.popup('/mem/MEM001P01', {prfCnt : res.data.prfCnt, mberAsgRegYn : this.mberAsgRegInfo.mberAsgRegYn})
									.then(res => {
										if(res) viewNm = res.viewNm;
										
										location.href = "/" + viewNm;
									});
							}else if(res.data.ncsCnt == 0 && (res.data.resumeAdmApprYn == 'Y' || res.data.prfCnt > 1)) {
								this.$.popup('/tec/prf/PRF101P02')
									.then(res => {
										if(res) viewNm = 'itpro/profile/ncs-result';
										
										location.href = "/" + viewNm;
									});
							}else {
							location.href = "/" + viewNm;
							}

						})
						.catch(err => {
							alert(err.response.data.error_description);
						});

					}else if(res.data.mberDivCd.substr(0, 1) == '0'){
						location.href = "/admin";
					}else {
						location.href = "/" + viewNm;
					}
				})
				.catch(this.$.httpErrorCommon);					
		},

		idChk() {
			const idTest = /^[a-z0-9]{4,16}$/;
			var idRes = idTest.test(this.id);

			if(idRes) {
				return true;
			} else {
				alert("아이디는 4~16자의 영문 소문자 / 숫자를 사용해야합니다.");
				return false;
			}
		},

		goKakao() {
			this.$.kakaoSync(this, function(this_obj, res) {
				this_obj.code = res;
				this_obj.accountSync();
			});
		},
		accountSync() {
			this.$.httpPost('/api/mem/kakao/accountSync', {code : this.code})
				.then(res => {
					this.userDstic = res.data.userDstic;

					if(this.userDstic == 'SYNC' || this.userDstic == 'LOGIN') {
						this.kakaoLogin(res.data.mberSeq);
							// .then((res) => {
							// 	this.$.httpPost('/api/mem/prf/getMberAsgRegInfo', {mberSeq : this.$store.state.userInfo.mberSeq})
							// 		.then(mberRes => {
							// 			this.mberAsgRegInfo = mberRes.data.mberAsgRegInfo;

							// 			var viewNm = 'MYP101M01';
										
							// 			// 이력서 등록대행 미완료 && 이력서 미작성 || 소속사 미등록
							// 			if((res.data.regAgncYn == 'N' && res.data.prfCnt == 0) ||this.mberAsgRegInfo.mberAsgRegYn == 'N') {
							// 				// this.$.popup('/tec/prf/PRF101P04')
							// 				this.$.popup('/mem/MEM001P01', {prfCnt : res.data.prfCnt, mberAsgRegYn : this.mberAsgRegInfo.mberAsgRegYn})
							// 					.then(res => {
							// 						viewNm = res.viewNm;
							// 						location.href = "/" + viewNm;
							// 					});
							// 			}else if(res.data.ncsCnt == 0 && (res.data.resumeAdmApprYn == 'Y' || res.data.prfCnt > 1)) {
							// 				this.$.popup('/tec/prf/PRF101P02')
							// 					.then(res => {
							// 						if(res) viewNm = 'PRF102M02';
													
							// 						location.href = "/" + viewNm;
							// 					});
							// 			}else {
							// 				location.href = "/" + viewNm;
							// 			}

							// 		})
							// 		.catch(err => {
							// 			alert(err.response.data.error_description);
							// 		});
							// });
					}else {
						this.mberInfo = res.data.mberInfo;
						// this.openStipPup(); // 2차 동의 팝업
						this.saveMember();
					}
					
				}).catch((err) => {
					var errResData = err.response.data;
					
					if(errResData && errResData.error_description != '')  {
						alert(errResData.error_description);
					}
				});
		},
		kakaoLogin(mberSeq) {
			this.$.loginKakao(mberSeq, 'kakaoSync', this.activeTab)
				.then(() => {
					// 로그인 후 화면 이동 > (25.05.19) 계정별 마이페이지에서 메인화면으로 변경
					// location.href = location.origin + '/MYP101M01?userDstic='+this.userDstic;
					var viewNm = "?userDstic="+ this.userDstic;

					// 타화면에서 미로그인 상태로 redirect시 로그인 이후 화면 설정 (임시)
					var history = this.$router.history;
					if(history.current.redirectedFrom) viewNm = history.current.redirectedFrom.replace('/','');

					location.href = "/" + viewNm;

				})
				.catch(this.$.httpErrorCommon);
		},
		openStipPup() {
			this.$.popup('/mem/MEM001P04')
				.then(res => {
					if(res) {
						var tempStip = {
							agreeYn: res.stipReChk.agreeYn ? 'Y' : 'N',
							stipDivCd: res.stipReChk.stipDivCd
						};

						this.mberInfo.stipList.push(tempStip);

						this.saveMember();
					}
				})
		},
		saveMember() {
			this.$.httpPost('/api/mem/insertMberInfo', {mberInfo: this.mberInfo}, '')
				.then(res => {
					if(res.data.resultCode == "000"){
						if(res.data.data.mberSeq) {
							this.kakaoLogin(res.data.data.mberSeq);
						}
					}else {
						alert(res.data.message);
					}
				})
				.catch(err => {
					alert(err.response.data.error_description);
				});
		},
		pageMove(name) {
			this.$router.push({name: name});
		}
	},
};
</script>
